<template>
  <div class="wrapper w-full h-full">
    <div class="login-bg w-full h-full" :style="headerStyle">
      <div class="logo-bar">
        <img :src="imgUrl" />
        <p>星地协同边坡自动化监测系统</p>
      </div>
      <Row class="align-items-center">
        <Col span="12">
        <div class="banner-content">
          <p class="des-title">实时监测预警</p>
          <p class="des-cont">
            利用物联网、云计算、大数据分析等先进技术,建立智能边坡安全监测系统,为边坡日常养护、管理和监测提供科学依据。
          </p>
          <p class="des-cont">
            系统提供包括GNSS监测、边坡深部变形监测、降雨量监测等实时监测功能
          </p>
        </div>
        </Col>
        <Col span="12">
        <div class="login-cont flex flex-col text-center bg-opacity-0">
          <div class="title">登录</div>
          <Form class="bg-opacity-0 rounded pt-6 pb-8 mb-4" ref="formInline" :model="formInline" :rules="ruleInline">
            <div class="currency-info">
              <span>用户名</span>
            </div>
            <FormItem prop="loginName">
              <Input type="text" prefix="ios-contact-outline" v-model="formInline.loginName" placeholder="请输入用户名" />
            </FormItem>
            <div class="currency-info">
              <span>密码</span>
            </div>
            <FormItem prop="password">
              <Input type="password" prefix="ios-lock-outline" v-model="formInline.password" placeholder="请输入密码" />
            </FormItem>
            <Button type="primary" @click="handleSubmit('formInline')">登录</Button>
          </Form>
        </div>
        </Col>
      </Row>
    </div>
    <footer>
      © 2020-2021 geosky.org.cn <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2021002400号-1</a>
      <img class="footer-img" :src="imgUrl" />江苏中科星地空间技术有限公司 技术支持
    </footer>
  </div>
</template>

<script>
import { signin } from '@/api/user';
import storage from '@/utils/local-storage';

export default {
  components: {},
  data() {
    return {
      formInline: {
        loginName: '',
        password: ''
      },
      ruleInline: {
        loginName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      imgUrl: require('@/assets/img/logo1.png')
    };
  },
  props: {
    header: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/back.png')
    }
  },
  computed: {
    headerStyle() {
      return {
        background: `url(${this.header})`
      };
    },
    logoStyle() {
      // eslint-disable-next-line global-require
      const logoImage = require('@/assets/img/cor.png');
      return {
        backgroundImage: `url(${logoImage})`
      };
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          const loginname = this.formInline.loginName.trim();
          const { password } = this.formInline;
          try {
            const userInfo = await signin({ loginname, password });
            const { accessToken } = userInfo;
            if (accessToken) {
              storage.setItem('user', JSON.stringify(userInfo), 24);
              debugger;
              if (loginname === 'ZJGS') {
                this.$appConfig.isZJ = true;
              } else {
                this.$appConfig.isZJ = false;
              }
              this.$router.push({ path: '/home' });
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          this.$Message.error('Fail!');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-content {
  padding: 100px 50px;
}

.des-title {
  color: #fff;
  font-size: 50px;
  font-family: 'chuangcu';
}

.des-cont {
  padding-top: 15px;
  color: #fff;
  font-size: 18px;
  font-family: 'songt';
  line-height: 40px;
}

::v-deep .ivu-btn {
  padding: 0px 100px;
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
  border: none;
  font-weight: bold;
  margin-top: 25px;
}

.login-bg {
  padding: 0 20px;
}

.login-cont {
  margin-top: 20px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 48px 0 rgb(0 0 0 / 8%);
  box-shadow: 0 2px 48px 0 rgb(0 0 0 / 8%);
  position: relative;
  z-index: 1;
  padding: 30px;
  height: 450px;
  width: 420px;
  border-radius: 5px;
  margin-left: 100px;
}

.login-cont::before {
  content: '';
  position: absolute;
  z-index: -1;
  background: #fff;
  width: 96%;
  opacity: 0.62;
  height: 50%;
  bottom: -10px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 3px;
}

.login-cont::after {
  content: '';
  position: absolute;
  z-index: -1;
  background: #fff;
  width: 96%;
  opacity: 0.62;
  height: 50%;
  top: -10px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 3px;
}

.align-items-center {
  align-items: center !important;
}

.logo-bar {
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  z-index: 999;
  background-color: transparent;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  padding-bottom: 20px;

  img {
    display: inline-block;
    padding-right: 10px;
    vertical-align: bottom;
    padding-top: 10px;
  }

  p {
    color: #fff;
    display: inline-block;
    font-size: 25px;
    font-family: 'chuangcu';
  }
}

.sys-name {
  color: #fff;
  text-align: left;
  margin-bottom: 30px;

  .en {
    font-size: 28px;
    font-weight: 600;
  }

  .ch {
    font-size: 16px;
    padding-top: 10px;
  }
}

.wrapper {
  ::v-deep .ivu-form-item {
    @apply text-left;
    margin-bottom: 5px;
    border: none;

    .ivu-form-item-content {
      line-height: 42px;
    }

    .ivu-input {
      background-color: transparent;
      height: 42px;
      border: none;
      color: #fff;

      &:focus {
        box-shadow: none;
      }
    }

    .ivu-input-prefix i,
    .ivu-input-suffix i {
      font-size: 24px;
      line-height: 42px;
      color: #fff;
    }
  }

  ::v-deep .ivu-form-item-label {
    @apply text-white;
    @apply font-bold;

    &:before {
      display: none;
    }
  }

  ::v-deep .ivu-input-with-prefix {
    padding-left: 45px;
  }

  ::v-deep .ivu-input-wrapper {
    margin-bottom: 15px;
    position: relative;
    background: linear-gradient(94deg, rgba(34, 83, 195, 1) 0%, rgba(45, 213, 253, 1) 100%);
    border-radius: 5px;
  }
}

footer {
  position: absolute;
  height: 30px;
  bottom: 0;
  width: 100%;
  color: #fff;
  line-height: 30px;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
}

.title {
  font-size: 20px;
  letter-spacing: 40px;
}

.footer-img {
  display: inline-block;
  height: 15px;
  margin: 0 5px;
  vertical-align: text-top;
}

.currency-info {
  text-align: left;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
}

.currency-info .bar {
  height: 100%;
  width: 2px;
  background: -webkit-gradient(linear, left top, right top, from(#23bdb8), to(#43e794));
  background: linear-gradient(90deg, #23bdb8 0%, #43e794 100%);
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.currency-info .bar::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  content: '';
  position: absolute;
  top: -1px;
  left: -2px;
  background: -webkit-gradient(linear, left top, right top, from(#23bdb8), to(#43e794));
  background: linear-gradient(90deg, #23bdb8 0%, #43e794 100%);
}

.currency-info .bar::after {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  content: '';
  position: absolute;
  bottom: -1px;
  left: -2px;
  background: -webkit-gradient(linear, left top, right top, from(#23bdb8), to(#43e794));
  background: linear-gradient(90deg, #23bdb8 0%, #43e794 100%);
}

.currency-info span {
  display: inline-block;
  color: #6084a4;
  font-size: 14px;
}

.currency-info span strong {
  color: #0e314c;
}

.currency-info span:last-child {
  margin-left: -10px;
}
</style>
